import {SimplePresentation} from "./SimplePresentationRunner";
import {Decadence} from "../../Decadence";
import {DecadenceSymbol} from "../../symbols/DecadenceSymbol";
import {gsap} from "gsap"

// Presentation for copying to and from the locked reel

export class DecadenceCopyFromLockedReelPresentation extends SimplePresentation {

    static readonly SCALE_DURATIONS:{[key:number]:number} = {
        1: 0.15,
        2: 0.15,
        4: 0.05,
    };

    constructor() {
        super("CopyFromLockedReel", false);
    }


    shouldRun(): boolean {
        return Decadence.model.isSuperFreeSpins;
    }

    buildTimeline() {
        const tl = this.tl;
        tl.add(() => {
            this.controller.setSkipCallback(() => {
                this.tl.seek("skip", false);
            })
        })
        const symbols = Decadence.reelView.getActiveSymbols();
        const numberOfReels = symbols.length;
        const scaleDur = DecadenceCopyFromLockedReelPresentation.SCALE_DURATIONS[numberOfReels];
        const copyFromTL = gsap.timeline();
        let copyIndex:number = 0;
        symbols.forEach( (sym) => {
            if(sym.isScatterSymbol) return;
            const lockedSymbol = Decadence.reelView.lockedSymbols[sym.reelID];

            //const evaluatedSym = Decadence.model.parsedEvaluatedArea[sym.reelID].symbol;

            if(Number(sym.name) < Number(lockedSymbol.name) && sym.name != lockedSymbol.name) {
                const symTL = gsap.timeline();
                symTL.add(() => {
                    Decadence.soundPlayer.playSound("valueScale");
                })
                symTL.add(lockedSymbol.animateScale());
                symTL.add(sym.animateScale(1.2, scaleDur));
                symTL.add(() => {
                    Decadence.soundPlayer.playSound("valueAdd");
                    sym.changeSymbol(lockedSymbol.name);
                })
                symTL.add(sym.animateScale(1, scaleDur));
                symTL.add(lockedSymbol.animateScale(1));
                copyFromTL.add(symTL, copyIndex * 0.37);
                copyIndex++;
            }
        })
        tl.add(copyFromTL);
        tl.addLabel("skip");
        tl.add(() => {
            this.controller.setSkipCallback()
        });

        tl.add(() => {}, ">0.1");
    }
}

export class DecadenceCopyToLockedReelPresentation extends SimplePresentation {
    constructor() {
        super("CopyToLockedReel");
    }

    shouldRun(): boolean {
        return Decadence.model.isSuperFreeSpins;
    }

    buildTimeline() {
        const tl = this.tl;
        const symbols = Decadence.reelView.getActiveSymbols();
        const copyToTL = gsap.timeline();
        symbols.forEach((sym, reel) => {
            if(sym.isScatterSymbol) return;
            const lockedSym = Decadence.reelView.lockedSymbols[sym.reelID];

            const symValue = Number(sym.name);
            if(symValue > Number(lockedSym.name)) {
                const symTL = gsap.timeline();
                symTL.add(sym.animateScale());
                symTL.add(() => {
                    Decadence.soundPlayer.playSoundNoOverlap("valueScale");
                })
                symTL.add(lockedSym.animateScale(1.2, 0.15))
                symTL.add(() => {
                    Decadence.soundPlayer.playSoundNoOverlap("valueAdd");
                    lockedSym.changeSymbol(sym.name);
                })
                symTL.add(lockedSym.animateScale(1, 0.15));
                symTL.add(sym.animateScale(1));
                copyToTL.add(symTL, 0);
            }
        })
        tl.add(copyToTL);
    }
}